import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule, MediaObserver } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { CommonMaterialComponentsModule } from '@quorum/common-material-components';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { NgPipesModule } from 'ngx-pipes';
import { InspectionCategoryComponent } from './inspection-category/inspection-category.component';
import { InspectionTypeSelectionComponent } from './inspection-type-selection/inspection-type-selection.component';
import { InspectionComponent } from './inspection/inspection.component';
import { VcrReportDisplayGmPrintComponent } from './vcr-report-display-gm-print/vcr-report-display-gm-print.component';
import { VcrReportDisplayGmComponent } from './vcr-report-display-gm/vcr-report-display-gm.component';
// eslint-disable-next-line max-len
import { VcrReportDisplayOnePagePrintComponent } from './vcr-report-display-one-page-print/vcr-report-display-one-page-print.component';
import { VcrReportDisplayOnePageComponent } from './vcr-report-display-one-page/vcr-report-display-one-page.component';
import { VcrReportDisplayPrintComponent } from './vcr-report-display-print/vcr-report-display-print.component';
import { VcrReportDisplayComponent } from './vcr-report-display/vcr-report-display.component';
import { VcrReportComponent } from './vcr-report/vcr-report.component';
import { VcrReportDisplayHyuPrintComponent } from './vcr-report-display-hyu-print/vcr-report-display-hyu-print.component';
// eslint-disable-next-line max-len
import { InspectionCauseCorrectionDialog } from './inspection-cause-correction-dialog/inspection-cause-correction-dialog.component';
import { MatRadioModule } from '@angular/material/radio';
import { ShaComponentsNgUiModule } from '@quorum/sha-components-ng-ui';
import { BodyReportComponent } from './body-report/body-report.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { BodyReportDamageComponent } from './body-report-damage/body-report-damage.component';
import { CommonPipesModule } from '@quorum/common-pipes';
import { SvcSignaturePadModule } from 'libs/svc-service-lane-ng-ui/src/lib/svc-signature-pad.module';
import { SharedDirectivesModule } from '@quorum/sha-directives';

@NgModule({
    imports: [
        CommonModule,
        CommonMaterialComponentsModule,
        MatRadioModule,
        FormsModule,
        NgPipesModule,
        FlexLayoutModule,
        MatButtonToggleModule,
        SatPopoverModule,
        ShaComponentsNgUiModule,
        OverlayModule,
        CommonPipesModule,
        SvcSignaturePadModule,
        SharedDirectivesModule
    ],
    declarations: [
        InspectionComponent,
        InspectionTypeSelectionComponent,
        InspectionCategoryComponent,
        InspectionCauseCorrectionDialog,
        VcrReportComponent,
        VcrReportDisplayComponent,
        VcrReportDisplayPrintComponent,
        VcrReportDisplayOnePageComponent,
        VcrReportDisplayOnePagePrintComponent,
        VcrReportDisplayGmComponent,
        VcrReportDisplayGmPrintComponent,
        VcrReportDisplayHyuPrintComponent,
        BodyReportComponent,
        BodyReportDamageComponent,
    ],
    exports: [  
        BodyReportComponent,
        InspectionComponent,
        InspectionTypeSelectionComponent,
        InspectionCategoryComponent,
        InspectionCauseCorrectionDialog,
        VcrReportComponent,
        VcrReportDisplayComponent,
        VcrReportDisplayPrintComponent,
        VcrReportDisplayOnePageComponent,
        VcrReportDisplayOnePagePrintComponent,
        VcrReportDisplayGmComponent,
        VcrReportDisplayGmPrintComponent,
        VcrReportDisplayHyuPrintComponent,
    ],
    providers: [MediaObserver]
})
export class XsrLegacyVipModule {}
